export class KvsRide {
  AanmeldDatum: string;
  AantalGescand: number;
  AantalTeScannen: number;
  HandelaarNaam: string;
  Kenteken: string;
  OpmerkingenRit: string;
  RitId: string;
  RitNummer: number;
}
